import { render, staticRenderFns } from "./MarketplaceActivationWizard.vue?vue&type=template&id=0cc2dd7e&scoped=true&"
import script from "./MarketplaceActivationWizard.vue?vue&type=script&lang=js&"
export * from "./MarketplaceActivationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2dd7e",
  null
  
)

export default component.exports